const Error404Page = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h1 className="my-2 text-3xl font-bold">404 Error</h1>
      <p>The page you requested could not be found.</p>
    </div>
  );
};

export default Error404Page;
